"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserV2Client = void 0;
const tslib_1 = require("tslib");
const new_crud_client_1 = require("./new.crud.client");
class UserV2Client extends new_crud_client_1.NewCrudClient {
    constructor() {
        super(...arguments);
        this.urlTemplate = '/v2/users';
    }
    search(parameters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const finalParams = Object.assign({}, parameters);
            delete finalParams.position;
            if (parameters.position) {
                finalParams.positions = [parameters.position];
            }
            const url = this.getPath(finalParams, null, finalParams);
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    findUser(userId, fields, includeDeleted) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/users/${userId}?${this.getQueryString({ fields, includeDeleted })}`);
            return response.payload || {};
        });
    }
    getUserTeam(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { userId } = request, params = tslib_1.__rest(request, ["userId"]);
            const response = yield this.httpGet(`/v2/users/${userId}/teams?${this.getQueryString(params)}`);
            return response.payload || [];
        });
    }
    getUserProjects(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { userId } = request, params = tslib_1.__rest(request, ["userId"]);
            const response = yield this.httpGet(`/v2/users/${userId}/projects?${this.getQueryString(params)}`);
            return response.payload || [];
        });
    }
    sendCreatePasswordEmail(email) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost('/v2/users/send-create-password-email', { email });
            return response.payload;
        });
    }
    checkEmail(email) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost('/v2/users/check-email', { email });
            return response.payload;
        });
    }
    migrateUser(userId, type, entityId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/users/migrate`, { userId, type, entityId });
            return response.payload;
        });
    }
    getCsmsByProjectId(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/users/projects/${projectId}/csm`);
            return response.payload || [];
        });
    }
    getAllEmployees(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/users/projects/${projectId}/employees`);
            return response.payload || [];
        });
    }
    isUserLabelMaster(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/users/projects/${projectId}/label-master`);
            return response.payload || false;
        });
    }
}
exports.UserV2Client = UserV2Client;
//# sourceMappingURL=user.v2.client.js.map